import axios from 'axios';
import { getDelivererApiUrl } from '../../../../services/env.service';

class DelivererApi {
  private static instance: DelivererApi;
  private readonly apiUrl: string;
  private constructor() {
    this.apiUrl = getDelivererApiUrl();
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new DelivererApi();
    }
    return this.instance;
  }

  public post(endpoint: string, data) {
    const url = this.buildUrl(endpoint, {});
    return axios.post(url, data);
  }

  private buildUrl(endPoint: string, filter: {}) {
    const query = this.parseFilters(filter);
    return `${this.apiUrl}/${endPoint}` + query;
  }

  private parseFilters(filter: {}) {
    let parsed = '';
    for (const key of Object.keys(filter)) {
      const glue = parsed === '' ? '?' : '&';
      parsed += `${glue}${key}=${JSON.stringify(filter[key])}`;
    }
    return parsed;
  }
}

const delivererApi = () => DelivererApi.getInstance();
export { delivererApi };
